module.exports = __webpack_public_path__ + "assets/4e40d0fe988c1978acb651e735f80757.mp3";